import { ButtonPosition } from '@/common/manager/position/button-position';
import { executeFunction, getRealRequestUrl, getRealizeValue, } from '@/common/util/util';
import { makeRequest } from '@/common/util/request';
import { getButtonAction } from '../index';
export const config = {
    value: 'submit',
    position: [
        ButtonPosition.formDialog,
        ButtonPosition.form,
        ButtonPosition.cardAction,
    ],
    action: (config) => {
        const { buttonConfig, formInstance, position, close, urlParamsDataSource, recordDataSource, state, _context, dialogRef, needSuccessToast: paramNeedSuccessToast, getExtraParam, getFormInstance, } = config;
        let realFormInstance = getRealizeValue(formInstance);
        if (typeof getFormInstance === 'function') {
            realFormInstance = getRealizeValue(executeFunction(getFormInstance));
        }
        if (buttonConfig && realFormInstance) {
            if (!realFormInstance?.submitting) {
                let afterRequestPosition;
                if (ButtonPosition.formDialog === position) {
                    afterRequestPosition =
                        ButtonPosition.formDialogSubmitAfterRequestSuccess;
                }
                else if (ButtonPosition.form === position) {
                    afterRequestPosition = ButtonPosition.formSubmitAfterRequestSuccess;
                }
                const { options } = buttonConfig || {};
                const { afterRequest = {}, requestConfig = {}, afterRequestNotCloseDialog, } = options || {};
                const realUrl = getRealRequestUrl({
                    requestConfig,
                    state,
                    extraParam: getExtraParam?.(),
                });
                if (realUrl) {
                    requestConfig.url = realUrl;
                    requestConfig.dynamicUrl = undefined;
                    requestConfig.useDynamicUrl = undefined;
                    return realFormInstance?.submit((value) => {
                        if (value) {
                            let needSuccessToast = true;
                            if (paramNeedSuccessToast !== undefined) {
                                needSuccessToast = paramNeedSuccessToast;
                            }
                            if (afterRequestPosition && afterRequest?.optType === 'message') {
                                needSuccessToast = false;
                            }
                            if ([ButtonPosition.cardAction].includes(position)) {
                                needSuccessToast = true;
                            }
                            return makeRequest({
                                buttonConfig,
                                urlParamsDataSource,
                                recordDataSource: value,
                                state,
                                needSuccessToast,
                                getExtraParam,
                                handleParams: () => {
                                    return value;
                                },
                                onCancel: () => {
                                    if (realFormInstance?.setSubmitting) {
                                        realFormInstance.setSubmitting(false);
                                    }
                                },
                                extraParamList: [
                                    dialogRef?.selectedRowKeys,
                                    dialogRef?.selectedRowRecords,
                                ],
                            })
                                .then((res) => {
                                const { optType } = afterRequest || {};
                                if (optType && afterRequestPosition) {
                                    const action = getButtonAction({
                                        ...afterRequest,
                                        position: afterRequestPosition,
                                    });
                                    action?.({
                                        position: afterRequestPosition,
                                        urlParamsDataSource,
                                        recordDataSource: getRealizeValue(recordDataSource),
                                        state,
                                        buttonConfig: afterRequest,
                                        _context,
                                        response: res,
                                        formInstance: realFormInstance,
                                    });
                                }
                                if (afterRequestNotCloseDialog !== true) {
                                    close && close();
                                }
                                return res;
                            })
                                .finally(() => {
                                if (realFormInstance?.setSubmitting) {
                                    realFormInstance.setSubmitting(false);
                                }
                            });
                        }
                    });
                }
                else {
                    return realFormInstance?.validate?.();
                }
            }
        }
    },
};
